import { useDispatch } from "react-redux";
import { useMutation } from "@tanstack/react-query";
import type { UseMutationOptions } from "@tanstack/react-query";

import type { AssessmentSubmissionParams, AssessmentSubmissionResponse, UUID } from "@/core/types";
import { removeTaskFromProfile } from "@/redux/actions/auth";
import { showToast } from "@/providers/ToastProvider";
import type { ToastConfig } from "@/ui2/molecules/Toast";

import { postAnswer } from "../queryFunctions/postAnswer";

type UseSubmitAssessmentOptions = {
  onSuccessCallback: () => void;
  taskId: UUID;
  toastConfig: ToastConfig;
} & UseMutationOptions<AssessmentSubmissionResponse, unknown, AssessmentSubmissionParams>;

export function useSubmitAssessment({
  onSuccessCallback,
  taskId,
  toastConfig,
  ...options
}: UseSubmitAssessmentOptions) {
  const dispatch = useDispatch();

  return useMutation({
    mutationFn: postAnswer,
    onSuccess: async () => {
      // Optimistically remove task from profile
      dispatch(removeTaskFromProfile(taskId));

      showToast([
        {
          heading: toastConfig.heading,
          text: toastConfig.text,
          variant: "success",
        },
      ]);

      onSuccessCallback();
    },
    ...options,
  });
}
